/**
 * A hook to retrieve related articles from `RelatedArticlesContext`
 *
 * @module
 */
import { useContext } from 'react';
import { useSelector } from '../actions/types';
import { categoryTree } from '../selectors';
import { ArticleFullContext } from '../contexts';
/**
 *
 * # useRelatedArticles
 *
 * Example usage:
 * ```javascript
 * import useRelatedArticles from '@elevio/kb-kit/lib/hooks';
 *
 * const MyRelatedArticles = () => {
 *   const relatedArticles = useRelatedArticles();
 *   console.log(relatedArticles); // IRelatedArticles | undefined
 *
 *   if (!relatedArticles) return null;
 *
 *   return (
 *     <div>
 *       {relatedArticles.map((article) => (
 *         <span key={article.id}>{article.title}</span>
 *       ))}
 *     </div>
 *   );
 * };
 * ```
 */
export function useRelatedArticles() {
    const article = useContext(ArticleFullContext);
    const relatedArticles = useSelector((state) => {
        if (!article)
            return null;
        return categoryTree.relatedArticles(state, article.id);
    });
    return relatedArticles;
}
//# sourceMappingURL=useRelatedArticles.js.map